import { useSpaceMetadataForPlan } from '@zep/apis';
import { PlanStatus } from '@zep/types';

import { useSpacePlanDetail } from './useSpacePlanDetail';

export enum DashboardAvailability {
  ACTIVATED = 'ACTIVATED',
  // 현재 대시보드 사용 가능 플랜은 아니지만 예전에 대시보드를 사용한 이력이 있는 경우
  INACTIVATED_AND_HAS_HISTORY = 'INACTIVATED_AND_HAS_HISTORY',
  INACTIVATED = 'INACTIVATED',
}

export function useDashboardAvailability({
  spaceHashId,
}: {
  spaceHashId: string;
}) {
  const { data: spacePlanDetail } = useSpacePlanDetail({ spaceHashId });
  const { data: spaceMetadataForPlan } = useSpaceMetadataForPlan({
    spaceHashId,
  });
  const countryCode = spacePlanDetail.space.countryCode;
  const planType = spacePlanDetail.spacePlan?.planType;
  const planStatus = spacePlanDetail.spacePlan?.status;

  const isDashboardActivated = (() => {
    if (planType == null || planStatus == null) {
      return false;
    }

    if (planStatus !== PlanStatus.ACTIVE) {
      return false;
    }

    // 정책: 일본에서 생성한 스페이스의 경우엔 엔터프라이즈 플랜만 대시보드 사용 가능
    return countryCode === 'JP'
      ? planType === 'ENTERPRISE'
      : ['PRO', 'ENTERPRISE'].includes(planType);
  })();

  if (isDashboardActivated) {
    return DashboardAvailability.ACTIVATED;
  }

  return spaceMetadataForPlan.hasUsedDashboard
    ? DashboardAvailability.INACTIVATED_AND_HAS_HISTORY
    : DashboardAvailability.INACTIVATED;
}
